import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { StyledWebstoreBasics } from './WebstoreBasics.styled';
import { getServiceArea } from '../../../lib/WebstoreAddressService/WebstoreAddressService';

const WebstoreBasics = (props) => {
    const { webstore, controls, sectionRef } = props;

    const { t } = useTranslation();

    const onlineOnlyWebstore = !webstore.PhysicalStore && !webstore.Travels && webstore.OnlineStore;

    const webstoreServiceArea = getServiceArea(webstore);

    return (
        <StyledWebstoreBasics id="webstore-basics" data-testid="webstore-basics">
            <div>
                <div className="textContainer">
                    <div className="basics-header">
                        <h1 ref={sectionRef}>{webstore.WebstoreName}</h1>
                        <div className="basics-controls">{controls}</div>
                    </div>
                    {(!!webstore?.businessVerificationStatus === true ||
                        !!webstore?.BusinessVerificationStatus === true) &&
                    !webstore?.IsCYB ? (
                        <div className="pearl-verification-bedge-wrapper">
                            <div className="pearl-verification-bedge">
                                <img
                                    src={'/Pearl_Verification_Bedge.png'}
                                    alt="pearl verification bedge"
                                />
                            </div>
                        </div>
                    ) : null}
                    <div className="subtitle">
                        <p className="p1">
                            {webstore.VendorCategoryName
                                ? webstore.VendorCategoryName
                                : webstore?.CrawledData
                                ? webstore?.CrawledData?.categoryName
                                : ''}
                        </p>
                        {(onlineOnlyWebstore || webstoreServiceArea) && (
                            <>
                                <p className="p2 separator">
                                    <b>.</b>
                                </p>
                                {onlineOnlyWebstore ? (
                                    <p className="p1">{t('WebstoreSections.About.OnlineOnly')}</p>
                                ) : (
                                    webstoreServiceArea && (
                                        <p className="p1">
                                            <span className="city-name">
                                                {webstoreServiceArea.city},{' '}
                                            </span>
                                            <span className="state-abbreviation">
                                                {webstoreServiceArea.state}
                                            </span>
                                        </p>
                                    )
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </StyledWebstoreBasics>
    );
};

WebstoreBasics.propTypes = {
    /**
     * Webstore object - placeholder
     */
    webstore: PropTypes.object,
};

WebstoreBasics.displayName = 'WebstoreBasics';

export default WebstoreBasics;
